module.exports = require('./helpers/bundle-url').getBundleURL('6Q9KC') + "logo.c51670a8.svg";